import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RecordDefinition } from "./recordDefinition.types";
import { getReturnTarget } from "./returnTarget";

/** Where Cancel and Save and close go: where Back goes, or back where the user came from. */
export function useCloseRoute(definition: RecordDefinition | undefined) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const target = getReturnTarget(definition, location.state);

    if (target) {
      navigate(target.path);
    } else {
      navigate(-1);
    }
  }, [definition, location.state, navigate]);
}
